export enum BLOCK_CAUSE_PERMISSIONS {
  BLOCK_CAUSE_VIEW = 'BLOCK_CAUSE_VIEW',
  BLOCK_CAUSE_WRITE = 'BLOCK_CAUSE_WRITE',
}
